import { v4 } from "uuid";
import { configureConsoleLoggersToForwardToGlobalLogger } from "~/utils/logging/configureConsoleLoggersToForwardToGlobalLogger";
import { configureSerilogIngestionSink } from "~/utils/logging/configureSerilogIngestion";
import { globalLogContext } from "~/utils/logging/logger";

globalLogContext.setBrowserSessionId(v4());
configureSerilogIngestionSink();
configureConsoleLoggersToForwardToGlobalLogger();
